import { TransitOperationFormValues } from 'features/declaration/models/schemas/transitOperationFormSchema'
import {
  toTransitOperationSave,
} from '../models/mapper'
import { createOrUpdateTransitOperation } from '../api/createOrUpdateTransitOperation'

function useTransitOperationFormSubmit(transitOperationId: number | null) {
  const saveTransitOperation = async (
    formValues: TransitOperationFormValues,
  ) => await createOrUpdateTransitOperation(transitOperationId, toTransitOperationSave(formValues))

  return {
    saveTransitOperation,
  }
}

export default useTransitOperationFormSubmit
